export function escapeODataString(value) {
  return String(value).replace(/'/g, "''");
}

export function odataFilterParam(filterExpression) {
  return encodeURIComponent(filterExpression);
}

export function mobileEqualsFilter(fieldName, mobile, extraConditions = '') {
  const base = `${fieldName} eq '${escapeODataString(mobile)}'`;
  return extraConditions ? `${base} and ${extraConditions}` : base;
}
